import React, { useMemo } from "react";
import { AbsoluteFill } from "remotion";
import { Animated, Fade, Move } from "remotion-animated";

interface BadgeStyle {
  entrance: "fadeIn" | "slideUp" | "slideDown";
  position:
    | "topLeft"
    | "topCenter"
    | "topRight"
    | "center"
    | "bottomLeft"
    | "bottomCenter"
    | "bottomRight";
  offsetX?: number;
  offsetY?: number;
  backgroundColor?: string;
  textColor: string;
  fontSize: number;
  fontWeight: number;
  fontFamily?: string;
  borderRadius: number;
  border?: string;
  paddingX: number;
  paddingY: number;
  textShadow?: string;
  boxShadow?: string;
  delay: number;
}

interface BadgeProps {
  text: string;
  style: BadgeStyle;
  durationInFrames: number;
}

/** 9 宫格 → flex 定位映射 */
const POSITION_MAP: Record<string, React.CSSProperties> = {
  topLeft: {
    position: "absolute",
    top: "8%",
    left: "10%",
  },
  topCenter: {
    position: "absolute",
    top: "8%",
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
  },
  topRight: {
    position: "absolute",
    top: "8%",
    right: "10%",
  },
  center: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  bottomLeft: {
    position: "absolute",
    bottom: "8%",
    left: "10%",
  },
  bottomCenter: {
    position: "absolute",
    bottom: "8%",
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
  },
  bottomRight: {
    position: "absolute",
    bottom: "8%",
    right: "10%",
  },
};

/**
 * Badge — 通用短文字标签组件
 *
 * 通过 preset 驱动。支持 9 宫格定位、3 种入场动画、
 * 可配置背景/边框/字体/阴影/发光。
 *
 * 在 layers[] 中放在 VisualEffect 之后 → 自然的顶层渲染。
 */
const Badge: React.FC<BadgeProps> = ({ text, style: s, durationInFrames }) => {
  const posStyle = POSITION_MAP[s.position ?? "topCenter"];

  const animations = useMemo(() => {
    const start = s.delay ?? 0;
    const anims: any[] = [Fade({ to: 1, initial: 0, start })];

    switch (s.entrance ?? "slideDown") {
      case "fadeIn":
        break;
      case "slideUp":
        anims.push(
          Move({ y: 0, initialY: 30, start, mass: 0.5, damping: 12 }),
        );
        break;
      case "slideDown":
        anims.push(
          Move({ y: 0, initialY: -30, start, mass: 0.5, damping: 12 }),
        );
        break;
    }

    return anims;
  }, [s.entrance, s.delay]);

  return (
    <AbsoluteFill style={{ pointerEvents: "none" }}>
      <div
        style={{
          ...posStyle,
          transform:
            s.offsetX || s.offsetY
              ? `translate(${s.offsetX ?? 0}px, ${s.offsetY ?? 0}px)`
              : undefined,
        }}
      >
        <Animated animations={animations}>
          <div
            style={{
              display: "inline-block",
              background: s.backgroundColor ?? undefined,
              borderRadius: s.borderRadius ?? 0,
              padding: `${s.paddingY ?? 0}px ${s.paddingX ?? 0}px`,
              border: s.border ?? undefined,
              boxShadow: s.boxShadow ?? undefined,
            }}
          >
            <span
              style={{
                fontSize: s.fontSize ?? 32,
                fontWeight: s.fontWeight ?? 700,
                color: s.textColor,
                fontFamily: s.fontFamily ?? "sans-serif",
                textShadow: s.textShadow ?? undefined,
                whiteSpace: "nowrap",
              }}
            >
              {text}
            </span>
          </div>
        </Animated>
      </div>
    </AbsoluteFill>
  );
};

export default Badge;
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
